const UnitSelector = (props) => {
    return (
        <div>
            <select
                className="form-control"
                style={{ height: "32px" }}
                value={props.value}
                disabled={props.disabled}
                onChange={props.onChange}
            >
                <option value="px">Pixels</option>
                <option value="%">Percent</option>
            </select>
        </div>
    );
}
export default UnitSelector;

